<template>
    <div 
      class="fill-height">
      <v-layout wrap>
        <v-flex>
          <section>
            <v-row
              class="pa-4 pb-2 pr-1">
              <v-col
                cols="12">
                <v-card
                  to="/master-pembelian/item"
                  flat
                  color="transparent"
                  style="width: 100%;">
                  <div
                    class="d-flex align-center">
                    <v-avatar
                      tile
                      size="28"
                      style="opacity: 30%;">
                      <v-img
                        contain
                        alt="POS Amanata"  
                        :src="require('@/assets/icon/back_arrow.png')">
                        <template v-slot:placeholder>
                          <v-row
                            class="fill-height"
                            align="center"
                            justify="center">
                            <v-progress-circular 
                              size="20"
                              indeterminate 
                              :color="set_color">
                            </v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>
                    </v-avatar>
  
                    <span
                      class="title black--text ml-3"
                      style="font-weight: 600;">
                      Tambah Item Pembelian
                    </span>
                  </div>
                </v-card>
              </v-col>
            </v-row>
  
            <v-row
              class="pa-4 pr-1">
              <v-col 
                cols="12"
                class="py-0">
                <v-card 
                  flat
                  min-height="calc(100vh - 315px)"
                  style="border-radius: 10px; border: 1px solid #E7E7E7; overflow-y: auto;">
                  <v-card-text>
                    <ValidationObserver 
                      ref="form">
                      <v-form>
                        <v-row>
                          <v-col
                            cols="12"
                            md="12">
                              <div class="body-2 mb-2">
  
                                Item
                              </div>
  
                              <v-autocomplete
                                v-on:keyup.enter="save()"
  
                                outlined
                                rounded
                                dense
  
                                :color="set_color"
                                placeholder="Contoh. Item"
  
                                hide-details
                                clearable
  
                                :items="item"
                                item-text="name"
                                item-value="id"
                                :item-color="set_color"
  
                                v-model="form.par_id"
                                style="border-radius: 10px;">
                              </v-autocomplete>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col
                            cols="12"
                            md="6">
                            <ValidationProvider 
                              name="Nama" 
                              rules="required" 
                              v-slot="{ errors, valid }">
                              <div class="body-2 mb-2">
                                <span class="red--text">*</span>
  
                                Nama
                              </div>
  
                              <v-text-field
                                v-on:keyup.enter="save()"
                                
                                outlined
                                rounded
                                dense
  
                                :color="set_color"
                                placeholder="Contoh. John Doe"
  
                                hide-details
  
                                v-model="form.name"
                                :error-messages="errors"
                                required
                                style="border-radius: 10px;">
                                <template v-slot:append-outer>
                                  <div v-if="errors.length > 0">
                                    <v-tooltip top color="#ff5252">
                                      <template v-slot:activator="{ on }">
                                        <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                      </template>
                                      
                                      {{ errors[0] }}
                                    </v-tooltip>
                                  </div>
                                  
                                  <div v-if="form.name !== '' && valid">
                                    <v-icon color="success">mdi-check-circle-outline</v-icon>
                                  </div>
                                </template>
                              </v-text-field>
                            </ValidationProvider>
                          </v-col>
  
  
                          <v-col
                            cols="12"
                            md="6">
                            <ValidationProvider 
                              name="Kategori Item"
                              rules="required"  
                              v-slot="{ errors, valid }">
                              <div class="body-2 mb-2">
                                <span class="red--text">*</span>
  
                                Kategori Item
                              </div>
  
                              <v-autocomplete
                                v-on:keyup.enter="save()"
  
                                outlined
                                rounded
                                dense
  
                                :color="set_color"
                                placeholder="Contoh. Makanan"
  
                                hide-details
  
                                :items="category"
                                item-text="name"
                                item-value="id"
                                :item-color="set_color"
  
                                v-model="form.category_item_id"
                                :error-messages="errors"
                                required
                                style="border-radius: 10px;">
                                <template v-slot:append-outer>
                                  <div v-if="errors.length > 0">
                                    <v-tooltip top color="#ff5252">
                                      <template v-slot:activator="{ on }">
                                        <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                      </template>
                                      
                                      {{ errors[0] }}
                                    </v-tooltip>
                                  </div>
                                  
                                  <div v-if="form.role !== '' && valid">
                                    <v-icon color="success">mdi-check-circle-outline</v-icon>
                                  </div>
                                </template>
                              </v-autocomplete>
                            </ValidationProvider>
                          </v-col>
  
                          <!-- <v-col
                            cols="12"
                            md="6">
                            <ValidationProvider 
                              name="Nomor Induk Pegawai" 
                              rules="required" 
                              v-slot="{ errors, valid }">
                              <div class="body-2 mb-2">
                                <span class="red--text">*</span>
  
                                Nomor Induk Pegawai
                              </div>
  
                              <v-text-field
                                v-on:keyup.enter="save()"
                                
                                outlined
                                rounded
                                dense
                                
                                :color="set_color"
                                placeholder="Contoh. 3102XXX"
                                
                                hide-details
  
                                v-model="form.nip"
                                :success="valid"
                                :error-messages="errors"
                                required
                                style="border-radius: 10px;">
                                <template v-slot:append-outer>
                                  <div v-if="errors.length > 0">
                                    <v-tooltip top color="#ff5252">
                                      <template v-slot:activator="{ on }">
                                        <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                      </template>
                                      
                                      {{ errors[0] }}
                                    </v-tooltip>
                                  </div>
                                  
                                  <div v-if="form.nip !== '' && valid">
                                    <v-icon color="success">mdi-check-circle-outline</v-icon>
                                  </div>
                                </template>
                              </v-text-field>
                            </ValidationProvider>
                          </v-col> -->
                        </v-row>
  
                        <v-row>
                          <v-col
                            cols="12"
                            md="6">
                            <ValidationProvider 
                              name="Satuan"
                              rules="required"  
                              v-slot="{ errors, valid }">
                              <div class="body-2 mb-2">
                                <span class="red--text">*</span>
  
                                Satuan
                              </div>
  
                              <v-autocomplete
                                v-on:keyup.enter="save()"
  
                                outlined
                                rounded
                                dense
  
                                :color="set_color"
                                placeholder="Contoh. pcs"
  
                                hide-details
  
                                :items="satuan"
                                item-text="name"
                                item-value="name"
                                :item-color="set_color"
  
                                v-model="form.satuan"
                                :error-messages="errors"
                                required
                                style="border-radius: 10px;">
                                <template v-slot:append-outer>
                                  <div v-if="errors.length > 0">
                                    <v-tooltip top color="#ff5252">
                                      <template v-slot:activator="{ on }">
                                        <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                      </template>
                                      
                                      {{ errors[0] }}
                                    </v-tooltip>
                                  </div>
                                  
                                  <div v-if="form.role !== '' && valid">
                                    <v-icon color="success">mdi-check-circle-outline</v-icon>
                                  </div>
                                </template>
                              </v-autocomplete>
                            </ValidationProvider>
                          </v-col>
  
                          <v-col
                            cols="12"
                            md="6">
                            <ValidationProvider 
                              name="Harga Beli" 
                              rules="required|min_value:0" 
                              v-slot="{ errors, valid }">
                              <div class="body-2 mb-2">
                                <span class="red--text">*</span>
  
                                Harga Beli
                              </div>
  
                              <v-currency-field
                                v-on:keyup.enter="save()"
  
                                outlined
                                rounded
                                dense
  
                                :color="set_color"
                                placeholder="Contoh. 10000"
  
                                hide-details
  
                                v-model="form.purchase_price"
                                :error-messages="errors"
                                required
                                style="border-radius: 10px;">
                                <template v-slot:append-outer>
                                  <div v-if="errors.length > 0">
                                    <v-tooltip top color="#ff5252">
                                      <template v-slot:activator="{ on }">
                                        <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                      </template>
                                      
                                      {{ errors[0] }}
                                    </v-tooltip>
                                  </div>
                                  
                                  <div v-if="form.purchase_price !== '' && valid">
                                    <v-icon color="success">mdi-check-circle-outline</v-icon>
                                  </div>
                                </template>
                              </v-currency-field>
                            </ValidationProvider>
                          </v-col>
                        </v-row>
  
                        <v-row>
                          <!-- <v-col
                            cols="12"
                            md="6">
                            <ValidationProvider 
                              name="Deskripsi"
                              rules="required"  
                              v-slot="{ errors, valid }">
                              <div class="body-2 mb-2">
                                <span class="red--text">*</span>
  
                                Deskripsi
                              </div>
  
                              <v-textarea
                                v-on:keyup.enter="save()"
  
                                outlined
                                rounded
                                dense
  
                                :color="set_color"
                                placeholder="Contoh. Deskripsi"
  
                                hide-details
  
                                v-model="form.desc"
                                :error-messages="errors"
                                required
                                style="border-radius: 10px;">
                                <template v-slot:append-outer>
                                  <div v-if="errors.length > 0">
                                    <v-tooltip top color="#ff5252">
                                      <template v-slot:activator="{ on }">
                                        <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                      </template>
                                      
                                      {{ errors[0] }}
                                    </v-tooltip>
                                  </div>
                                  
                                  <div v-if="form.desc !== '' && valid">
                                    <v-icon color="success">mdi-check-circle-outline</v-icon>
                                  </div>
                                </template>
                              </v-textarea>
                            </ValidationProvider>
                          </v-col> -->
  
                          <v-col
                            cols="12"
                            md="6">
                            <ValidationProvider 
                              name="Catatan"
                              rules="required"  
                              v-slot="{ errors, valid }">
                              <div class="body-2 mb-2">
                                <span class="red--text">*</span>
  
                                Catatan
                              </div>
  
                              <v-textarea
                                v-on:keyup.enter="save()"
  
                                outlined
                                rounded
                                dense
  
                                :color="set_color"
                                placeholder="Contoh. catatan"
  
                                hide-details
  
                                v-model="form.note"
                                :error-messages="errors"
                                required
                                style="border-radius: 10px;">
                                <template v-slot:append-outer>
                                  <div v-if="errors.length > 0">
                                    <v-tooltip top color="#ff5252">
                                      <template v-slot:activator="{ on }">
                                        <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                      </template>
                                      
                                      {{ errors[0] }}
                                    </v-tooltip>
                                  </div>
                                  
                                  <div v-if="form.desc !== '' && valid">
                                    <v-icon color="success">mdi-check-circle-outline</v-icon>
                                  </div>
                                </template>
                              </v-textarea>
                            </ValidationProvider>
                          </v-col>
                        </v-row>
  
                        <v-row>
                          <v-col cols="12">
                            <div class="">
                            <div 
                              class="fs-15 label-input mb-2">
                              <!-- <span class="red--text">*</span> -->
                              Gambar
                            </div>
                            <uploadfolder
                              v-model="upload.image_url" 
                              style="height: 250px; width: 250px">
                              <div 
                                slot="activator"
                                class="cursor-pointer">
                                <v-card 
                                  flat
                                  height="250"
                                  class="d-flex align-center justify-center"
                                  style="border-radius: 15px;
                                        border: 2px solid #eaeaea; 
                                        border-style: dashed;">
                                  <div v-if="form.image_url.length < 1">
                                    <v-icon v-if="!process.image_url"
                                      size="60" 
                                      color="#718EBF">
                                      mdi-cloud-upload-outline
                                    </v-icon>
  
                                    <v-progress-circular v-else
                                      indeterminate
                                      :color="set_color">
                                    </v-progress-circular>
                                  </div>
  
                                  <v-img v-else
                                    contain
                                    height="250"
                                    :src="form.image_url" 
                                    :alt="form.image_url"
                                    class="text-center d-flex align-center">
                                    <div 
                                      class="d-flex aling-center justify-center" 
                                      style="width: 100%; height: auto;">
                                      <v-icon v-if="!process.image_url"
                                        size="60" 
                                        color="white">
                                        mdi-cloud-upload-outline
                                      </v-icon>
  
                                      <v-progress-circular v-else
                                        indeterminate
                                        :color="set_color">
                                      </v-progress-circular>
                                    </div>
                                  </v-img>
                                </v-card>
                              </div>
                            </uploadfolder>
                          </div>
                          </v-col>
                        </v-row>
  
                        <!-- <v-row>
                          <v-col
                            cols="12"
                            md="6">
                            <ValidationProvider 
                              name="Jenis Kelamin" 
                              rules="required"
                              v-slot="{ errors, valid }">
                              <div class="body-2 mb-2">
                                <span class="red--text">*</span>
                                
                                Jenis Kelamin
                              </div>
  
                              <v-select
                                v-on:keyup.enter="save()"
  
                                outlined
                                rounded
                                dense
  
                                :color="set_color"
                                placeholder="Contoh. Laki-Laki"
  
                                hide-details
  
                                :items="['Laki-Laki', 'Perempuan']"
                                :item-color="set_color"
  
                                v-model="form.gender"
                                :success="valid"
                                :error-messages="errors"
                                required
                                style="border-radius: 10px;">
                                <template v-slot:append-outer>
                                  <div v-if="errors.length > 0">
                                    <v-tooltip top color="#ff5252">
                                      <template v-slot:activator="{ on }">
                                        <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                      </template>
                                      
                                      {{ errors[0] }}
                                    </v-tooltip>
                                  </div>
                                  
                                  <div v-if="form.gender !== '' && valid">
                                    <v-icon color="success">mdi-check-circle-outline</v-icon>
                                  </div>
                                </template>
                              </v-select>
                            </ValidationProvider>
                          </v-col>
                        </v-row> -->
  
                      </v-form>
                    </ValidationObserver>
  
                    <div v-if="message.error.length > 0"
                      class="text-center my-4 d-flex align-center">
                      <div
                        class="error--text">
                        <v-icon size="18" color="red">mdi-alert-circle-outline</v-icon>
                        
                        <span
                          class="ml-1">
                          {{ message.error }}
                        </span>
                      </div>
                    </div>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
  
            <v-row
              justify="end"
              class="pa-4 pr-1">
              <v-col 
                cols="12"
                md="12"
                class="d-flex align-center justify-end py-0">
                <v-btn
                  @click="save()"
                  :loading="process.form"
                  :disabled="process.form"
                  elevation="0"
                  color="#240087"
                  class="body-2 white--text text-capitalize border-radius">
                  <v-icon
                    size="20">
                    mdi-checkbox-marked-circle-outline
                  </v-icon>
  
                  <span
                    class="ml-2">
                    Simpan
                  </span>
                </v-btn>
                
                <v-btn
                  to="/master-pembelian/item"
                  :disabled="process.form"
                  color="red"
                  elevation="0"
                  class="body-2 white--text text-capitalize d-flex align-center ml-4"
                  style="border-radius: 10px; font-weight: 600;">
                  <v-icon 
                    size="20">
                    mdi-progress-close
                  </v-icon>
  
                  <span
                    class="ml-2">
                    Batal
                  </span>
                </v-btn>
              </v-col>
            </v-row>
          </section>
        </v-flex>
      </v-layout>
    </div>
  </template>
  
  <script>
    import { get, post, put, patch, destroy } from "@/service/Axios";
    import moment from "moment"
    import "moment/locale/id"
    export default {
      data () {
        return {
          category: [],
          satuan: [],
          item: [],
          detail: {},
  
          form: {
            id: '',
            name: '',
            par_id: '',
            category_item_id: '',
            
            outlet_id: '',
  
            satuan: '',
            image_url: '',
            desc: '',
            note: '',
            purchase_price: ''
  
          },
          upload: {
            image_url: null
          },
  
          process: {
            form: false,
  
            image_url: false
          },
          
          message: {
            success: '',
            error: ''
          }
        }
      },
      components: {
        uploadfolder: () => import(/* webpackPrefetchCategory: true */ '@/components/upload/folder.vue')
      },
      watch: {
        'upload.image_url': {
          handler: function () {
            if (this.upload.image_url) {
              this.process.image_url = this.upload.image_url.process
  
              if (!this.process.image_url) {
                // CALLBACK FROM UPLOAD IMAGE
                
                this.form.image_url = this.upload.image_url.fileuri
  
                // this.save_image()
              }
            }
          },
          deep: true
        }
      },
      computed: {
        user () {
          return this.$store.state.user
        },
        outlet () {
          return this.$store.state.outlet
        },
        rps () {
          return this.$vuetify.breakpoint.name
        },
        fcm () {
          return this.$store.state.fcm
        },
        isDay () {
          let hours = (new Date()).getHours(),
              day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
          return day
        },
        set_color () {
          return this.$store.state.color
        },
        set_color_rgb () {
          let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))
  
          return `rgba(${r}, ${g}, ${b}, 0.97)`
        },
        set_color_rgb_up () {
          let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))
  
          return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
        },
        set_color_rgb_down () {
          let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))
  
          return `rgba(${r}, ${g}, ${b}, 0.25)`
        }
      },
      mounted () {
        this.fetchDetail()
      },
      methods: {
        async fetchDetail () {
          let params = {
            id: this.$route.params.id,
            outlet_id: this.outlet.outlet_id
          }
  
          await get(`pos/pembelian/item/detail`, { params })
          .then(response => {
            let res = response.data
  
            if (res.status === 200) {
              this.detail = res.results.data
              this.form.id = this.detail.id
              this.form.name = this.detail.name
              this.form.par_id = this.detail.par_id
              this.form.category_item_id = this.detail.category_item_id
              this.form.satuan = this.detail.satuan
              this.form.image_url = this.detail.image_url
              this.form.desc = this.detail.desc
              this.form.note = this.detail.note
              this.form.purchase_price = this.detail.purchase_price

              this.fetchCategory()
              this.fetchSatuan()
              this.fetchItem()
            }
          })
        },
        async fetchSatuan () {
          let params = {
            limit: 100000000000
          }
  
          await get(`pos/satuan/data`, { params })
          .then(response => {
            let res = response.data
  
            if (res.status === 200) {
              this.satuan = res.results.data
            }
          })
        },
        async fetchCategory () {
          let params = {
            limit: 100000000000,
            outlet_id: this.outlet.outlet_id
          }
  
          await get(`pos/pembelian/category_item/data`, { params })
          .then(response => {
            let res = response.data
  
            if (res.status === 200) {
              this.category = res.results.data
            }
          })
        },
  
        async fetchItem () {
          let params = {
            limit: 100000000000,
            outlet_id: this.outlet.outlet_id,
            'id[nin]': this.form.id,
            'par_id[nin]': this.form.id
          }
  
          await get(`pos/pembelian/item/data`, { params })
          .then(response => {
            let res = response.data
  
            if (res.status === 200) {
              this.item = res.results.data
            }
          })
        },
  
        async save () {
          this.message.error = ''
  
          const isValid = await this.$refs.form.validate()
          if (isValid) {
            this.process.form = true
            this.form.par_id = this.form.par_id === null || this.form.par_id === '' ? '0' : this.form.par_id
  
            // SAVE TO REST API
            await post(`pos/pembelian/item/update`, {
              data: this.form
            })
            .then((response) => {
              let res = response.data
  
              this.process.form = false
  
              if (res.status === 200) {
  
                this.$router.push({ path: `/master-pembelian/item/detail/${this.form.id}` })
  
              } else {
                this.message.error = res.message
              }
            })
            
          } else {
            // AUTO FOCUS ON TEXT-FIELD
            setTimeout(() => {
              const errors = Object.entries(this.$refs.form.errors)
                .map(([key, value]) => ({ key, value }))
                .filter(error => error['value'].length)
              this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
                behavior: 'smooth',
                block: 'center'
              })
            }, 10)
          }
        }
      }
    }
  </script>